"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAvatarStyle;

function createAvatarStyle(_ref) {
  var accent = _ref.accent,
      avatarSize = _ref.avatarSize,
      primaryFont = _ref.primaryFont;
  return {
    alignItems: 'center',
    backgroundColor: accent,
    borderRadius: '50%',
    color: 'White',
    display: 'flex',
    fontFamily: primaryFont,
    height: avatarSize,
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'relative',
    width: avatarSize,
    '& > .image': {
      left: 0,
      position: 'absolute',
      top: 0
    }
  };
}